import { handleApiError, HandleApiErrorOptions, OmniaErrorHandler } from "../error"
import { IOmniaSession } from "../types"
import { showMessageBox } from "./msgbox"

export type ApiErrorHandler = ReturnType<typeof createErrorHandler>

export function createErrorHandler(sessionProvider: () => IOmniaSession) {

    return (response: { status: number, data: any }, options?: HandleApiErrorOptions) => {

        const session = sessionProvider()

        const errorHandler: OmniaErrorHandler = {

            userId: session.currentUser.Id,
            sessionId: session.sessionId,

            showMessageBox: showMessageBox

        }

        return handleApiError(errorHandler, response, options)

    }

}
